import {Align, Justify} from '@wonderlandengine/react-ui';
import {Button, Text, Container, Image, MaterialContext, Panel9Slice} from '@wonderlandengine/react-ui/components';
import React, {useState, useEffect, Children, useContext, useMemo, forwardRef, PropsWithChildren} from 'react';
import {FlatOpaqueTextured, FlatOpaqueTexturedAlpha, Text as TextMaterial} from '../../types/matdef.js';
import {useSs13MaterialContext} from './utils/ss13-material-context.js';
import {Material, Object3D} from '@wonderlandengine/api';
import {colorSwatch} from './utils/colorSwatch.js';
import {parseColor} from './utils/utils.js';

export const MenuButton = (props) => {
    // <Image rounding={0} src="UI\UI_0.png" width={160} height={32} />
    const mat = useSs13MaterialContext();
    const matDefault = useContext(MaterialContext);
    const textHoverMaterial = useMemo(() => {
        const t = matDefault.textMaterial.clone() as TextMaterial;
        t.setColor(parseColor(colorSwatch.TextHover));
        t.setEffectColor(parseColor(colorSwatch.TextHoverOutline));
        return t;
    }, []);

    const [hovered, setHovered] = useState(false);

    const propsHovered = {
        material: mat.buttonHover,
    };
    const propsUnhovered = {
        material: mat.buttonMaterial,
    };

    const textProps = {
        material: matDefault.textMaterial,
    };
    const textPropsHovered = {
        material: textHoverMaterial,
    };

    let propsMerged = {
        ...props,
        ...(hovered ? propsHovered : propsUnhovered),
    };
    let textPropsMerged = {
        ...(hovered ? textPropsHovered : textProps),
    };

    useEffect(() => {
        propsMerged = {
            ...props,
            ...(hovered ? propsHovered : propsUnhovered),
        };
        textPropsMerged = {
            ...(hovered ? textPropsHovered : textProps),
        };
    }, []);

    return (
        <Container>
            <Panel9Slice
                {...propsMerged}
                width={props.width ?? 128}
                height={32}
                borderSize={16}
                onHover={() => setHovered(true)}
                onUnhover={() => setHovered(false)}
                onClick={props.onClick}
                borderTextureSize={0.33}
                justifyContent={Justify.Center}
                alignItems={Align.Center}
                alignContent={Align.Center}
                padding={0}
            >
                <Text textAlign="center" z={0.01} marginTop={4} fontSize={props.fontSize ?? 24} {...textPropsMerged}>
                    {props.children}
                </Text>
            </Panel9Slice>
        </Container>
    );
};
